export const CRITERIO_COBRANCA_UNICA = 0
export const CRITERIO_COBRANCA_MENSAL = 1
export const CRITERIO_COBRANCA_POR_USO = 2

export const FORMA_PAGAMENTO_PRE = 0
export const FORMA_PAGAMENTO_POS = 1
